import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../../../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

// Images
import NoPlayer from "../../../Assets/Images/Selekcije/Seniori/No-Player.jpg";
import NKPodsusedBijelaBg from "../../../Assets/Images/Ostalo/NK-Podsused-Bijela-Bg.jpg";
import NKPodsusedBijelaPhoneBg from "../../../Assets/Images/Ostalo/NK-Podsused-Bijela-Phone-Bg.jpg";
import Main from "../Home/Main";

export default function MlPioniri() {
  const [coach, setCoach] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "NK Podsused | Mlađi pioniri";

    const PODSUSED_DOC_REF = doc(db, "podsused", "podsused");

    const fetchCoach = async () => {
      try {
        const docSnap = await getDoc(PODSUSED_DOC_REF);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const treneri = data.treneri || [];

          const mlPioniriCoach = treneri.find(
            (coach) => coach.selection === "Mlađi pioniri"
          );

          if (mlPioniriCoach) {
            setCoach(mlPioniriCoach);
          } else {
            setError("Trener nije pronađen.");
          }
        } else {
          setError("Podaci nisu pronađeni.");
        }
      } catch (error) {
        setError("Došlo je do pogreške prilikom dohvaćanja trenera.");
      } finally {
        setLoading(false);
      }
    };

    fetchCoach();
    window.scrollTo(0, 0);
  }, []);

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Main
        desktopBackground={NKPodsusedBijelaBg}
        phoneBackground={NKPodsusedBijelaPhoneBg}
        title="MLAĐI PIONIRI"
      />
      <div className="seniori section">
        <div className="podsused-team">
          {/* TRENER SECTION */}
          <h3>TRENER</h3>
          <div className="team-grid">
            {loading && <p className="center">Učitavanje...</p>}{" "}
            {/* Show loading */}
            {error && <p className="center">{error}</p>} {/* Show error */}
            {!loading && !error && coach && (
              <Coach image={coach.image || NoPlayer} name={coach.name} />
            )}
          </div>
        </div>
        <Link
          className="btn"
          to="/ostale-utakmice"
          onClick={() => handleClick("/")}
        >
          Utakmice &rarr;
        </Link>
      </div>
    </>
  );
}

function Coach({ image, name }) {
  return (
    <div className="player-box">
      <img src={image} alt={name} />
      <h3>{name}</h3>
    </div>
  );
}
